import {
  mapApiResourceToBranding,
  type Branding,
  type BrandingApiResource,
} from '@/api/branding/brandingApi.types';

export interface HostWorkspaceApiResource {
  tenant_id: string;
  hostname: string;
  is_primary: boolean;
  primary_hostname: string;
  default_language: string;
  branding: BrandingApiResource | null;
}

export interface HostWorkspace {
  tenantId: string;
  hostname: string;
  primaryHostname: string;
  defaultLanguage: string;
  branding: Branding | null;
}

export function mapApiResourceToHostWorkspace(resource: HostWorkspaceApiResource): HostWorkspace {
  return {
    tenantId: resource.tenant_id,
    hostname: resource.hostname,
    primaryHostname: resource.primary_hostname,
    defaultLanguage: resource.default_language,
    branding: resource.branding === null ? null : mapApiResourceToBranding(resource.branding),
  };
}
